// client/src/dnd/emitter_tool/engine/engine_parts/emitter/PulseFollower.js
const EPS = 1e-6;

export function onSpawn(p, originX, originY, pulseScale = 1) {
  const s = Math.max(EPS, Number(pulseScale) || 1);
  const px = Number(p?.x) || 0;
  const py = Number(p?.y) || 0;
  p.__pulseFollow = {
    anchorX: px - originX,
    anchorY: py - originY,
    birthScale: s,
    lastRatio: 1,
    lastOriginX: originX || 0,
    lastOriginY: originY || 0,
    enabled: true,
  };
}

export function updateParticle(p, originX, originY, pulseScale = 1, opts = {}) {
  const meta = p && p.__pulseFollow;
  if (!meta) return;
  if ((opts.enabled === false) || meta.enabled === false) return;

  const cur = Math.max(EPS, Number(pulseScale) || 1);
  const birth = Math.max(EPS, Number(meta.birthScale) || 1);
  const ratio = cur / birth;

  // follow origin drift
  const dOx = (originX || 0) - (meta.lastOriginX || 0);
  const dOy = (originY || 0) - (meta.lastOriginY || 0);
  if (dOx || dOy) {
    p.x += dOx;
    p.y += dOy;
    meta.lastOriginX = originX || 0;
    meta.lastOriginY = originY || 0;
  }

  // follow pulse delta
  const dr = ratio - (meta.lastRatio || 1);
  if (dr) {
    p.x += (meta.anchorX || 0) * dr;
    p.y += (meta.anchorY || 0) * dr;
    meta.lastRatio = ratio;
  }
}

export function updateAll(containerOrArray, originX, originY, pulseScale = 1, opts = {}) {
  if (!containerOrArray) return;
  const list = Array.isArray(containerOrArray) ? containerOrArray : (containerOrArray.children || []);
  for (let i = 0; i < list.length; i++) updateParticle(list[i], originX, originY, pulseScale, opts);
}

export default { onSpawn, updateParticle, updateAll };
